export const toDate = value => {
  if (!value) return null;
  if (value?.toDate) return value.toDate();
  const raw = String(value);
  const parsed = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? new Date(`${raw}T00:00:00`) : new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDate = (value, options = {}) => {
  const date = toDate(value);
  if (!date) return 'Not recorded';
  return date.toLocaleDateString('en-ZA', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options
  });
};

export const formatDateTime = value => {
  const date = toDate(value);
  if (!date) return 'Not recorded';
  return date.toLocaleString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const personName = person => {
  const name = `${person?.firstName || ''} ${person?.lastName || ''}`.trim();
  return name || person?.name || person?.fullName || person?.email || 'Not recorded';
};

export const courseName = course => course?.title || course?.name || course?.intake || 'Course';

export const humanize = value => String(value || '')
  .replace(/[_-]+/g, ' ')
  .replace(/\b\w/g, letter => letter.toUpperCase());

export const timestampValue = value => toDate(value)?.getTime() || 0;
